/**
 * Товари крамниці: українська.
 *
 * Про склад файлу — див. goods-ru.ts.
 *
 * ⚠️ РИБАЛЬСЬКІ НАЗВИ, А НЕ КАЛЬКА. «Волосінь», «повідець», «гачок»,
 * «коливалка», «оберталка» — саме так це зветься українською, і саме ці слова
 * шукає гравець у крамниці.
 */
export const ТОВАРЫ_UK: Record<string, string> = {
  // ── было в общем словаре ──
  'item.test': 'тест до',
  'item.drag': 'фрикціон до',
  'item.dive': 'заглиблення',
  'item.action_fast': 'швидкий стрій',
  'item.action_medium': 'середній стрій',
  'item.action_slow': 'повільний стрій',
  'item.mat_mono': 'монофіл',
  'item.mat_fluoro': 'флюорокарбон',
  'item.mat_braid': 'плетінка',
  'item.rod_medium': 'Спінінг «Медіум» 2,4 м',
  'item.rod_ultralight': 'Спінінг «Ультралайт» 1,98 м',
  'item.rod_light': 'Спінінг «Лайт» 2,13 м',
  'item.rod_heavy': 'Спінінг «Хеві» 2,7 м',
  'item.reel_stock': 'Котушка 2500',
  'item.reel_3000': 'Котушка 3000',
  'item.reel_4000': 'Котушка 4000',
  'item.line_mono_024': 'Монофіл 0,24 мм',
  'item.line_mono_030': 'Монофіл 0,30 мм',
  'item.line_fluoro_022': 'Флюорокарбон 0,22 мм',
  'item.line_braid_014': 'Плетінка 0,14 мм',
  'item.line_braid_020': 'Плетінка 0,20 мм',
  'item.lure_spoon_18': 'Коливалка 18 г',
  'item.lure_spinner_8': 'Вертушка 8 г',
  'item.lure_wobbler_12': 'Воблер 12 г',
  'item.lure_wobbler_deep': 'Воблер глибинний 16 г',
  'item.lure_jig_14': 'Джиг 14 г',
  'item.lure_jig_24': 'Джиг 24 г',
  'item.lead_fluoro': 'Повідець флюорокарбон 0,20 мм',
  'item.lead_steel': 'Повідець сталевий 12 кг',
  'item.hook_10': 'Гачок № 10',
  'item.hook_8': 'Гачок № 8',
  'item.hook_6': 'Гачок № 6',
  'item.hook_4': 'Гачок № 4',
  'item.bait_corn': 'Кукурудза',
  'item.bait_worm': 'Черв’як гнойовий',
  'item.bait_maggot': 'Опариш',
  'item.bait_fry': 'Живець',
  'item.gb_basic': 'Прикормка базова',
  'item.gb_aroma': 'Прикормка ароматизована',
  'item.food_sandwich': 'Бутерброд',
  'item.food_tea': 'Термос із чаєм',
  'item.food_stew': 'Тушонка',
  'item.food_ration': 'Пайок на день',
  'item.keep_150': 'Садок на 150 риб',
  'item.keep_250': 'Садок на 250 риб',
  'item.keep_400': 'Садок на 400 риб',
  'item.sonar_shore': 'Ехолот береговий',
  'item.sonar_far': 'Ехолот далекий',
  'item.boat_row': 'Човен весловий',
  'item.boat_motor': 'Човен моторний',
  'item.net_small': 'Підсака мала',
  'item.net_big': 'Підсака велика',
  'item.lamp_head': 'Ліхтар налобний',
  'item.lamp_camp': 'Ліхтар кемпінговий',
  'item.tent_solo': 'Намет одномісний',
  'item.tent_duo': 'Намет двомісний',
  'item.cloth_rain': 'Дощовик',
  'item.cloth_warm': 'Костюм теплий',
  'item.gear_chair': 'Стілець складаний',
  'item.gear_box': 'Ящик рибальський',
  'item.gear_thermos': 'Термос',
  'item.gear_scales': 'Ваги',
  'item.gear_tape': 'Рулетка',
  'item.gear_stringer': 'Кукан',


  // ── удилища ──
  'item.rod_spin_ul_21': 'Спінінг «Ультралайт» 2,10 м',
  'item.rod_spin_jig_27': 'Спінінг джиговий 2,70 м',
  'item.rod_spin_twitch_21': 'Спінінг твічинговий 2,10 м',
  'item.rod_spin_sea_30': 'Спінінг важкий 3,00 м',
  'item.rod_feeder_33': 'Фідер легкий 3,30 м',
  'item.rod_feeder_36': 'Фідер середній 3,60 м',
  'item.rod_feeder_39': 'Фідер важкий 3,90 м',
  'item.rod_match_42': 'Вудилище матчеве 4,20 м',
  'item.rod_bolo_50': 'Вудилище болонське 5,00 м',
  'item.rod_pole_60': 'Вудилище махове 6,00 м',
  'item.rod_carp_36': 'Вудилище коропове 3,60 м',
  'item.rod_fly_5': 'Вудилище нахлистове 5 класу',
  'item.rod_fly_8': 'Вудилище нахлистове 8 класу',
  'item.rod_tele_40': 'Вудилище телескопічне 4,00 м',
  'item.rod_troll_24': 'Вудилище тролінгове 2,40 м',
  'item.rod_ice': 'Вудка зимова',

  // ── катушки ──
  'item.reel_1000': 'Котушка 1000',
  'item.reel_2000': 'Котушка 2000',
  'item.reel_5000': 'Котушка 5000',
  'item.reel_8000': 'Котушка 8000',
  'item.reel_baitrunner': 'Котушка з байтранером',
  'item.reel_feeder': 'Котушка фідерна',
  'item.reel_rear_drag': 'Котушка із заднім фрикціоном',
  'item.reel_carp_big': 'Котушка коропова',
  'item.reel_multi': 'Мультиплікатор',
  'item.reel_troll': 'Котушка тролінгова',
  'item.reel_fly': 'Котушка нахлистова',
  'item.reel_ice': 'Котушка зимова',

  // ── леска ──
  'item.line_mono_016': 'Монофіл 0,16 мм',
  'item.line_mono_020': 'Монофіл 0,20 мм',
  'item.line_mono_028': 'Монофіл 0,28 мм',
  'item.line_mono_035': 'Монофіл 0,35 мм',
  'item.line_fluoro_018': 'Флюорокарбон 0,18 мм',
  'item.line_fluoro_028': 'Флюорокарбон 0,28 мм',
  'item.line_braid_010': 'Плетінка 0,10 мм',
  'item.line_braid_025': 'Плетінка 0,25 мм',
  'item.line_feeder_022': 'Волосінь фідерна 0,22 мм',
  'item.line_carp_030': 'Волосінь коропова 0,30 мм',
  'item.line_ice_012': 'Волосінь зимова 0,12 мм',
  'item.line_shock': 'Шок-лідер',

  // ── поводки ──
  'item.lead_mono': 'Повідець монофільний 0,16 мм',
  'item.lead_titan': 'Повідець титановий 9 кг',
  'item.lead_tungsten': 'Повідець вольфрамовий 7 кг',
  'item.lead_kevlar': 'Повідець кевларовий 15 кг',
  'item.lead_carp': 'Повідець плетений для коропа',
  'item.lead_fly': 'Підлісок нахлистовий',

  // ── крючки ──
  'item.hook_14': 'Гачок № 14',
  'item.hook_12': 'Гачок № 12',
  'item.hook_2': 'Гачок № 2',
  'item.hook_1_0': 'Гачок № 1/0',
  'item.hook_treble': 'Трійник',
  'item.hook_double': 'Двійник',
  'item.hook_offset': 'Гачок офсетний',
  'item.hook_carp': 'Гачок для коропа',

  // ── приманки ──
  'item.lure_spoon_7': 'Коливалка 7 г',
  'item.lure_spoon_28': 'Коливалка 28 г',
  'item.lure_spinner_3': 'Оберталка 3 г',
  'item.lure_spinner_14': 'Оберталка 14 г',
  'item.lure_minnow_90': 'Воблер-міноу 90 мм',
  'item.lure_crank_60': 'Воблер-кренк 60 мм',
  'item.lure_shad_70': 'Воблер-шед 70 мм',
  'item.lure_popper_80': 'Попер 80 мм',
  'item.lure_walker_95': 'Волкер 95 мм',
  'item.lure_jerk_130': 'Джеркбейт 130 мм',
  'item.lure_swim_150': 'Свімбейт складений 150 мм',
  'item.lure_jighead_12': 'Джиг-головка 12 г',
  'item.lure_sil_worm': 'Силіконовий черв’як',
  'item.lure_sil_shad': 'Силіконовий віброхвіст',
  'item.lure_sil_twister': 'Силіконовий твістер',
  'item.lure_mandula': 'Мандула',
  'item.lure_fly_wet': 'Мушка мокра',
  'item.lure_fly_dry': 'Мушка суха',

  // ── наживка ──
  'item.bait_bloodworm': 'Мотиль',
  'item.bait_barley': 'Перлівка',
  'item.bait_dough': 'Тісто',
  'item.bait_peas': 'Горох',
  'item.bait_boilie': 'Бойли',
  'item.bait_pellets': 'Пелетс',
  'item.bait_mussel': 'Скойка річкова',
  'item.bait_shrimp': 'Рачок-бокоплав',
  'item.bait_bread': 'Хлібний м’якуш',
  'item.bait_cheese': 'Сир',

  // ── прикормка ──
  'item.gb_bream': 'Прикормка «Лящ»',
  'item.gb_carp': 'Прикормка «Короп»',
  'item.gb_roach': 'Прикормка «Плітка»',
  'item.gb_feeder': 'Прикормка фідерна',
  'item.gb_winter': 'Прикормка зимова',
  'item.gb_dip': 'Ароматизатор-діп',
  'item.gb_pva': 'ПВА-мішки',
  'item.gb_soil': 'Ґрунт для прикормки',

  // ── еда ──
  'item.food_soup': 'Казанок з юшкою',
  'item.food_coffee': 'Кава',
  'item.food_energy': 'Енергетик',
  'item.food_bar': 'Батончик',

  // ── садки ──
  'item.keep_60': 'Садок 60 см',
  'item.keep_cage': 'Садок прогумований',
  'item.keep_sack': 'Мішок для коропа',

  // ── эхолоты ──
  'item.sonar_wireless': 'Ехолот бездротовий',
  'item.sonar_color': 'Ехолот кольоровий з картою',
  'item.sonar_ice': 'Ехолот зимовий',

  // ── лодки ──
  'item.boat_pvc': 'Човен надувний ПВХ',
  'item.boat_outboard': 'Мотор підвісний',
  'item.boat_mount': 'Кріплення ехолота',
  'item.boat_anchor': 'Якір човновий',

  // ── снаряжение ──
  'item.gear_forceps': 'Екстрактор',
  'item.gear_pliers': 'Плоскогубці риболовні',
  'item.gear_mat': 'Мат для коропа',
  'item.gear_rodpod': 'Род-под',
  'item.gear_umbrella': 'Парасоля риболовна',
  'item.gear_bag': 'Сумка для снастей',
  'item.gear_bucket': 'Відро для прикормки',
  'item.gear_polar': 'Окуляри поляризаційні',

  // ── нахлыст: вторая сотня видов ──
  'item.fly_line_5': 'Нахлистовий шнур 5 класу',
  'item.fly_line_8': 'Нахлистовий шнур 8 класу',
  'item.fly_backing': 'Бекінг нахлистовий',
  'item.fly_tippet': 'Матеріал для повідців',
  'item.fly_box': 'Коробка для мушок',
  'item.fly_dry_set': 'Набір сухих мушок',
  'item.fly_wet_set': 'Набір мокрих мушок',
  'item.fly_nymph_set': 'Набір німф',
  'item.fly_streamer': 'Стример',
  'item.fly_hegene': 'Гірлянда німф',
  'item.fly_floatant': 'Флотант',
  'item.fly_sink': 'Паста для затоплення',
  'item.fly_vice': 'Лещата для вʼязання мушок',

  // ── наживка: вторая сотня видов ──
  'item.bait_caddis': 'Личинка волохокрильця',
  'item.bait_roe': 'Ікра лососева',
  'item.bait_cut': 'Різана риба',
  'item.bait_grasshopper': 'Зелений коник',
  'item.bait_algae': 'Нитчасті водорості',
  'item.bait_frog': 'Жаба',
  'item.bait_fruit': 'Фрукти',
  'item.bait_meat': 'Мʼясо',
  'item.bait_mussel_tropic': 'Велика річкова скойка',

  // ── поводки: вторая сотня видов ──
  'item.lead_wire_20': 'Повідець сталевий 20 кг',
  'item.lead_wire_40': 'Повідець сталевий 40 кг',
  'item.lead_shock_heavy': 'Ударний повідець 60 кг',
  'item.lead_mono_heavy': 'Повідець монофільний 1,0 мм',

  // ── крючки: вторая сотня видов ──
  'item.hook_3_0': 'Гачок № 3/0',
  'item.hook_6_0': 'Гачок № 6/0',
  'item.hook_circle': 'Гачок круглий',
  'item.hook_fly': 'Гачок нахлистовий',

  // ── снаряжение: вторая сотня видов ──
  'item.gear_waders': 'Забрідний костюм',
  'item.gear_boots': 'Забрідні черевики',
  'item.gear_glove': 'Рукавиця для трофея',
  'item.gear_lipgrip': 'Захват для риби',
  'item.gear_gaff': 'Багор',
  'item.gear_cooler': 'Термосумка',
  'item.gear_repellent': 'Засіб від мошки',
  'item.gear_marker': 'Маркерний поплавок',

  'item.float_light_1g': "Поплавець легкий 1 г",
  'item.float_mid_3g': "Поплавець середній 3 г",
  'item.float_heavy_6g': "Поплавець важкий 6 г",

  'item.float_quill_05': 'Поплавець-перо 0,5 г',
  'item.float_waggler_4g': 'Ваглер 4 г',
  'item.float_slider_8g': 'Поплавець ковзний 8 г',
  'item.rod_pole_90': 'Вудилище штекерне 9,00 м',
};
